import '../domPolyfills/closest';

export function setAttr(dataValue, dataKey, selector = null, children = null) {
  const targetSelector = selector || `[${dataKey}]`;

  const target =
    (children && children.closest
      ? children.closest(targetSelector)
      : document.querySelector(targetSelector)) || null;

  if (target) {
    target.setAttribute(dataKey, dataValue);
  }
}
